 <!--Main COintainer Starts-->
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div [@routerTransition]>
  <!--User Profile wizard Starts-->
  <div class="row  margin-left-25px margin-top-15px margin-right-25px">
    <!--<div class="row">
      <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" ><i class="fas fa-angle-double-left font-size-19px"></i> Patient List</a>
    </div>-->

    <div class="col-md-2">
      <div class="margin-top-22px">
        <a class="nav-link-hand  back-link left-arrow-treatmentcycle" title="Back To TreatmentCycles" (click)="BackToTreatment()" *ngIf="titleapp != 'Profile'"><i class="fas fa-angle-double-left font-size-19px"></i></a>
        <a class="nav-link-hand  back-link left-arrow-treatmentcycle" title="Back To Profile" (click)="BackToProfile2()" *ngIf="titleapp == 'Profile'"><i class="fas fa-angle-double-left font-size-19px"></i></a>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12  padding-right-0px padding-left-0px">


        <div class="nurse-profile-card-body primary-background padding-bottom-0px">
          <div class="row">

            <div class="position-fixed-patient2  height-567px ">
              <div class="row margin-right-0px padding-top-2px" *ngFor="let l of CurrentTreatmentCyclesByActorCodeController">
                <div class="col-md-12 padding-right-7px">
                  <div class=" card  height-100pe profile-card-border">
                    <div class="card-body padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px margin-left-0px">


                      <div class="">
                        <div class="row">
                          <div class="col-md-12 text-align-center padding-top-20px padding-left-0px padding-right-0px">
                            <img class="img-circle-50" [src]='l.OwnerPatientImageFile' onError="this.src='dummy.jpg';">
                          </div>
                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-top-5px">
                          <div class="col-md-12">
                            <h4 class="margin-bottom-0px  font-size-20px margin-left-3px font-weight-bold text-align-center">{{l.OwnerName}}</h4>
                            <!--<h4 class="margin-bottom-0px  font-size-20px margin-left-3px font-weight-bold text-align-center" *ngIf="titleapp == 'App' || titleapp == 'cycle' ">{{Displaynameapp}}</h4>-->
                          </div>

                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-bottom-10px">
                          <div class="col-md-12">
                            <h4 class="margin-bottom-0px color-#999999 font-size-12px margin-left-3px font-weight-normal text-align-center">{{l.OwnerFormattedCode}}</h4>
                            <!--<h4 class="margin-bottom-0px color-#999999 font-size-12px margin-left-3px font-weight-normal text-align-center" *ngIf="titleapp == 'App' || titleapp == 'cycle' ">{{FormattedCodeapp}}</h4>-->
                          </div>

                        </div>

                      </div>

                      <div class="background-color-wt">

                        <div class="row margin-left-3px margin-right-0px padding-top-15px">
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{l.OwnerAgeYears}}</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <div [ngSwitch]="l.OwnerGender">
                              <div *ngSwitchCase="'F'" class="font-size-12px">
                                <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">Female</h4>
                              </div>
                              <div *ngSwitchCase="'M'" class="font-size-12px">
                                <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">Male</h4>
                              </div>
                              <div *ngSwitchCase="'O'" class="td-brorder-8px-blue font-size-12px">
                                <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">Other</h4>
                              </div>
                            </div>
                            <!--<h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{SelectedPatient.Gender}}</h4>-->
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{l.CycleType}}</h4>
                          </div>
                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-bottom-15px">
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px margin-left-3px font-weight-normal text-align-center">Age</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px margin-left-3px font-weight-normal text-align-center">Sex</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px margin-left-3px font-weight-normal text-align-center">Cycle Type</h4>
                          </div>
                        </div>
                        
                      </div>
                    </div>

                  </div>

                  <!--<div class="card  ">
                    <div class="card-header background-primary border-bottom-0px padding-top-6px   padding-bottom-0px padding-left-7px border-left-female font-weight-normal2 label-table-color">
                      <div class=""><label class="margin-bottom-0px font-size-15px">{{l.OwnerName}}</label></div>
                      <div [ngSwitch]="l.OwnerGender">
                        <div *ngSwitchCase="'F'" class="font-size-12px">
                          Female,{{l.OwnerAgeYears}}
                        </div>
                        <div *ngSwitchCase="'M'" class="font-size-12px">
                          Male,{{l.OwnerAgeYears}}
                        </div>


                        <div *ngSwitchCase="'O'" class="td-brorder-8px-blue font-size-12px">
                          Other,{{l.OwnerAgeYears}}
                        </div>
                      </div>
                    </div>
                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px margin-left-0px">
                      <div class="row  margin-top-10 margin-bottom-10">

                        <div class="offset-md-3 col-md-9 padding-left-0px">
                          <img class="img-circle-50" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
                        </div>

                      </div>
                    </div>


                  </div>-->
                </div>


              </div>
              <div class="row margin-bottom-5px">
                <div class="col-md-12">
                  <div class="chatsd product-chart-wrapper product-chat-width-ivf  agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                    <div class="accordion" id="accordionExample">
                      <div class="card border-top-15px-new box-shadow-new-treatmentcycle">
                        <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                          <h5 class="mb-0 height-24px" *ngIf="SelectedTreatmentCycle">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              <i class="fas fa-sync color-cycle-icon"></i> Cycle
                            </button>
                            <button type="button" class="btn btn-secondary font-size-13px  actions-btn-prime-badge margin-right-5px float-right margin-top-3px background-blue">{{SelectedTreatmentCycle.TCModelName}}</button>
                          </h5>
                        </div>

                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                            <div class="margin-left-10px">
                              <div class="row margin-left-0px height-16px" *ngIf="SelectedTreatmentCycle">

                                <div class="col-md-12">
                                  <label class="margin-bottom-0px font-size-12px">{{SelectedTreatmentCycle.CycleType}}</label>
                                </div>
                              </div>
                              <div class="row margin-left-0px height-16px" *ngIf="SelectedTreatmentCycle">

                                <div class="col-md-12">
                                  <label class="margin-bottom-0px font-size-12px">{{SelectedTreatmentCycle.ProtocolName}}</label>
                                </div>
                              </div>
                              <div class="row margin-left-0px height-16px" *ngIf="SelectedTreatmentCycle">

                                <div class="col-md-6 padding-right-0px padding-left-13px">
                                  <label class="margin-bottom-0px font-size-12px">{{SelectedTreatmentCycle.ProtocolStartDate| date:'dd-MM-yyyy'}}</label>
                                </div>
                              </div>
                              <div class="row margin-left-0px">

                                <div class="col-md-5">
                                  <label class="margin-bottom-0px font-size-12px">{{Duration}} days</label>
                                </div>
                              </div>
                              <!--<div class="row margin-left-0px">

                                <div class="col-md-12" *ngFor="let l of CurrentCounsellingPlanController">
                                  <label class="margin-bottom-0px font-size-12px">{{l.TreatmentPlan}}</label>
                                </div>
                              </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion" id="Members">
                      <div class="card  box-shadow-new-treatmentcycle">
                        <div class="card-header wh-header border-all-0px  font-weight-normal label-table-color background-primary border-top-0px border-right-0  border-bottom-0px padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px" id="headingTwo">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                              <i class="fas fa-users color-member-icon"></i> Members
                            </button>
                          </h5>
                        </div>
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#Members">
                          <div class="card-body padding-left-0px padding-top-0px padding-bottom-0px margin-left-0px padding-right-0px">

                            <div class="row padding-all-5px  rowfor-2  margin-left-zero margin-right-0px margin-top-5px" *ngFor="let l of CurrentIvfCycleMembersListController">
                              <div class="col-md-4 padding-right-0px padding-left-10px">
                                <!--<img class="img-circle-40" src='dummy.jpg'>-->
                                <img class="img-circle-40" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">
                              </div>
                              <div class="col-md-6 padding-left-10px padding-right-0px">
                                <div class="row">
                                  <label class="margin-bottom-0px font-size-13px ">{{l.MemberType}}</label>
                                </div>
                                <div class="row">
                                  <label class="margin-bottom-0px font-size-11px">{{l.gender}},{{l.MemberAge}}</label>
                                </div>
                                <!--<div class="row" *ngIf="l.MemberType=='Sperm'">
                                  <label class="margin-bottom-0px font-size-11px">Male,{{l.MemberAge}}</label>
                                </div>
                                <div class="row" *ngIf="l.MemberType=='Egg'">
                                  <label class="margin-bottom-0px font-size-11px">Female,{{l.MemberAge}}</label>
                                </div>
                                <div class="row" *ngIf="l.MemberType=='Recepient'">
                                  <label class="margin-bottom-0px font-size-11px">Female,{{l.MemberAge}}</label>
                                </div>-->
                              </div>
                            </div>
                            <!--<div class="row padding-all-5px  rowfor-2  margin-left-zero margin-right-0px margin-top-5px">
                              <div class="col-md-4 padding-right-0px padding-left-10px">
                                <img class="img-circle-40" src='dummy.jpg'>
                              </div>
                              <div class="col-md-6 padding-left-10px padding-right-0px">

                                <div class="row">
                                  <label class="margin-bottom-0px font-size-13px">Egg Donor</label>
                                </div>
                                <div class="row">
                                  <label class="margin-bottom-0px font-size-11px">FeMale,31</label>
                                </div>

                              </div>
                            </div>
                            <div class="row padding-all-5px rowfor-2  margin-top-5px margin-left-0px margin-right-0px">
                              <div class="col-md-4 padding-right-0px padding-left-10px">
                                <img class="img-circle-40" src='dummy.jpg'>
                              </div>
                              <div class="col-md-6 padding-left-10px padding-right-0px">
                                <div class="row">
                                  <label class="margin-bottom-0px font-size-13px">Surrogate</label>
                                </div>
                                <div class="row">
                                  <label class="margin-bottom-0px font-size-11px">FeMale,41</label>
                                </div>

                              </div>
                            </div>-->

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion" id="StorageBank">
                      <div class="card  box-shadow-new-treatmentcycle">
                        <div class="card-header wh-header border-left-storagebank background-primary label-table-color border-bottom-0px font-weight-normal border-top-0px border-right-0  border-bottom-0px padding-top-0px padding-right-0px padding-left-7px padding-bottom-0px" id="headingThree">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                              Storage Bank
                            </button>
                          </h5>
                        </div>
                        <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#StorageBank">
                          <div class="card-body padding-left-0px padding-top-0px padding-bottom-0px margin-left-0px padding-right-0px text-align-center margin-top-10 margin-bottom-10">
                            <!--<div class="card margin-bottom-0px margin-top-5px">
                              <div class="card-header border-all-0px padding-top-5 padding-bottom-5px padding-left-16px padding-right-0px">
                                Egg
                              </div>
                              <div class="card-body padding-top-0px padding-right-0px padding-bottom-0px margin-left-0px padding-left-0px margin-left-10px margin-right-10px">
                                <div class="row margin-right-0px margin-left-0px border-top-1px border-bottom-light2">
                                  <div class="col-md-4 padding-left-10px padding-right-0px text-align-left border-left-1px border-right-1px">
                                    <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Total</label></div>
                                    <div><label class="margin-bottom-0px font-size-14">4</label></div>
                                  </div>
                                  <div class="col-md-4 padding-left-10px padding-right-0px text-align-left border-right-1px">
                                    <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Used</label></div>
                                    <div><label class="margin-bottom-0px font-size-14">2</label></div>
                                  </div>
                                  <div class="col-md-4 padding-left-10px padding-right-0px text-align-left border-right-1px">
                                    <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Balance</label></div>
                                    <div><label class="margin-bottom-0px font-size-14">2</label></div>
                                  </div>
                                </div>
                              </div>
                            </div>-->
                            <button (click)="openstorage()" class="btn font-size-13px actions-btn-prime margin-right-5px">Open Storage</button>
                            <!--<button></button>-->
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>



                </div>
              </div>





            </div>


          </div>

        </div>
      </div>
    </div>
    <div class="col-md-7 padding-right-10px padding-left-9px">
      <div>
        <div class="row margin-right-0px margin-left-0px" hidden>
          <div class="col-md-12 padding-left-0px padding-right-0px">
            <div class="accordion" id="data">
              <div class="card margin-bottom-0px">
                <div class="card-header padding-top-0px padding-bottom-0px border-all-0px margin-top-5px" id="head">
                  <div class="row">
                    <div class="col-md-3 padding-left-0px">
                      <h5 class="mb-0">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseNew" aria-expanded="true" aria-controls="collapseOne">
                          Lab
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-9 padding-left-0px">
                      <a class="nav-link-hand float-right " (click)="AddDetails()">
                        <i class="fas fa-ellipsis-h"></i>
                      </a>
                    </div>
                  </div>

                </div>

                <div id="collapseNew" class="collapse show" aria-labelledby="head" data-parent="#data">
                  <div class="card-body padding-bottom-0px padding-top-7px padding-left-7px">
                    <div class="row margin-bottom-5px border-top-1px border-bottom-light2 margin-right-0px margin-left-0px">
                      <div class="col border-right-1px border-left-1px padding-right-10px padding-left-10px text-align-left">
                        <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">BP</label></div>
                        <div><label class="margin-bottom-0px font-size-14">80/140</label></div>
                      </div>
                      <div class="col border-right-1px padding-right-10px padding-left-10px text-align-left">
                        <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">FDOS</label></div>
                        <div><label class="margin-bottom-0px font-size-14">80</label></div>
                      </div>
                      <div class="col border-right-1px padding-right-10px padding-left-10px text-align-left">
                        <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">E2</label></div>
                        <div><label class="margin-bottom-0px font-size-14">70</label></div>
                      </div>
                      <div class="col border-right-1px padding-right-10px padding-left-10px text-align-left">
                        <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">LH</label></div>
                        <div><label class="margin-bottom-0px font-size-14">70</label></div>

                      </div>
                      <div class="col border-right-1px padding-right-10px padding-left-10px text-align-left">
                        <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">PRO</label></div>
                        <div><label class="margin-bottom-0px font-size-14">70</label></div>
                      </div>
                      <div class="col border-right-1px padding-right-0px padding-left-0px text-align-center">

                      </div>
                      <div class="col  border-right-1px padding-right-0px padding-left-0px text-align-center">

                      </div>
                      <div class="col  border-right-1px padding-right-0px padding-left-0px text-align-center">

                      </div>
                      <div class="col border-right-1px padding-right-0px padding-left-0px text-align-center">

                      </div>
                      <div class="col border-right-1px padding-right-0px padding-left-0px text-align-center">

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>





        <div class="row new-color  padding-top-10px padding-left-10px padding-bottom-5px padding-right-10px light-border-new margin-left-0px margin-right-0px" hidden>
          <div class="margin-right-10px">
            <a class=" padding-bottom-5px color-datacolor font-weight-normal text-decoration font-size-13px scans nav-link-hand" (click)="scans()">
              <i class="fas fa-circle light-gray-badge nav-link-hand  ">
              </i> Scans
            </a>
          </div>
          <div class="margin-left-5px margin-right-10px">
            <a class=" padding-bottom-5px color-datacolor font-weight-normal text-decoration font-size-13px scans nav-link-hand" (click)="pickUp()">
              <i class="fas fa-circle light-gray-badge nav-link-hand  ">
              </i> Pick up
            </a>
          </div>
          <div class="margin-left-5px margin-right-10px">
            <a class=" padding-bottom-5px color-datacolor font-weight-normal text-decoration font-size-13px scans nav-link-hand" (click)="OQA()">
              <i class="fas fa-circle light-gray-badge nav-link-hand  ">
              </i> OQA
            </a>
          </div>
          <div class="margin-left-5px margin-right-10px">
            <a class=" padding-bottom-5px color-datacolor font-weight-normal text-decoration font-size-13px scans nav-link-hand " (click)="onClick()">
              <i class="fas fa-circle light-gray-badge nav-link-hand  ">
              </i> PSA
            </a>
          </div>
          <div class="margin-left-5px margin-right-10px">
            <a class="padding-bottom-5px color-datacolor font-weight-normal text-decoration font-size-13px scans nav-link-hand" (click)="InseminationLog()">
              <i class="fas fa-circle light-gray-badge nav-link-hand  ">
              </i> PS
            </a>
          </div>
          <div class="margin-left-5px margin-right-10px">
            <a class=" padding-bottom-5px color-datacolor font-weight-normal text-decoration font-size-13px scans nav-link-hand" (click)="Grading()">
              <i class="fas fa-circle light-gray-badge nav-link-hand  ">
              </i> GRadu
            </a>
          </div>
          <div class="margin-left-5px margin-right-10px">
            <a class="padding-bottom-5px color-datacolor font-weight-normal text-decoration font-size-13px scans nav-link-hand" (click)="ET()">
              <i class="fas fa-circle light-gray-badge nav-link-hand  ">
              </i> ET
            </a>
          </div>


        </div>
        <div class="row margin-right-0px margin-left-0px" id="top">
          <div class="col-md-12 padding-left-0px padding-right-0px">
            <div class="accordion" id="accordionExample8">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                  <div class="row">
                    <div class="col-md-7">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                          <i class="fas fa-sync color-cycle-icon"></i> Cycle Status
                        </button>
                      </h5>
                    </div>

                    <div class="col-md-5 padding-right-24px">
                      <button (click)="RefreshAll()" class="btn btn-link float-right  padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" title="Refresh" >
                        <i class="fas fa-redo color-cycle-icon"></i>
                      </button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample8">
                  <div class="card-body padding-top-5 padding-bottom-10px margin-left-0px padding-left-5px padding-right-5px">
                    <div class="row   margin-right-0px margin-left-0px">
                      <div class="col1 background-treatment-status nav-link-hand border-top-1px border-left-1px border-right-1px "
                           *ngFor="let l of CurrentTreatmentCycleStatusController" (click)="Goto(l)">
                        <label class="font-size-12px margin-left-3px nav-link-hand">{{l.PhaseActivity}}</label>
                        <div *canUserAccess="['ChangeCycleStatus']">
                          <a class="padding-left-5px" *ngIf="l.ActivityStatus=='Completed'"
                             (click)="EditStatus(l)"><i class="fas fa-pencil-alt nav-link-hand font-size-12px margin-top-5px"></i></a>
                        </div>
                      </div>
                      </div>
                    <div class="row margin-right-0px margin-left-0px">
                      <div class="col1 nav-link-hand border-top-1px border-left-1px border-right-1px " *ngFor="let l of CurrentTreatmentCycleStatusController" (click)="Goto(l)">
                        <!--<label class="font-size-12px margin-left-3px">{{l.PhaseActivity}}</label>-->
                        <div class="linegreen" *ngIf="l.ActivityStatus=='Completed'">

                        </div>
                        <div class="lineblue" *ngIf="l.ActivityStatus=='Initiated'">

                        </div>
                        <div class="linered" *ngIf="l.ActivityStatus=='Cancelled'">

                        </div>
                        <div class="linelightgray" *ngIf="l.ActivityStatus=='Not Initiated'">

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div *ngIf="FollicularData2 || RefreshData=='Load' || RefreshData!=='Load'">
        <!--<follicularscan [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode" *ngIf="FollicularData2.ActivityStatus =='Completed' || FollicularData2.ActivityStatus =='Initiated'"></follicularscan>-->
        <follicularscan2 (GoFollicle)="OnGoFollicle()" [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode"
                         [LMPDate]="LMPDate" [GradingModel]="GradingModel"
                         *ngIf="FollicularData2.ActivityStatus =='Completed' || FollicularData2.ActivityStatus =='Initiated'"></follicularscan2>
      </div>
      <div *ngIf="PickupData2">
        <!--<pickup [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode" *ngIf="PickupData2.ActivityStatus =='Completed' || PickupData2.ActivityStatus =='Initiated'"></pickup>-->
        <pickup2 (GoFollicle)="OnGoFollicle()" [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode"
                 [GradingModel]="GradingModel"
                 *ngIf="PickupData2.ActivityStatus =='Completed' || PickupData2.ActivityStatus =='Initiated'"></pickup2>
      </div>

      <div *ngIf="OocyteData2">
        <!--<oqaview [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode" [GradingModel]="GradingModel" *ngIf="OocyteData2.ActivityStatus =='Completed' || OocyteData2.ActivityStatus =='Initiated'"></oqaview>-->
        <oqaview2 (GoFollicle)="OnGoFollicle()" [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode"
                  [GradingModel]="GradingModel"
                  *ngIf="OocyteData2.ActivityStatus =='Completed' || OocyteData2.ActivityStatus =='Initiated'"></oqaview2>
      </div>
      <div *ngIf="SemanAnalysis2">
        <!--<spermcollection [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode" [GradingModel]="GradingModel" *ngIf="SemanAnalysis2.ActivityStatus =='Completed' || SemanAnalysis2.ActivityStatus =='Initiated'"></spermcollection>-->
        <spermcollection2 (GoFollicle)="OnGoFollicle()" [ActorCode]="PatientActorCode"
                          [CycleCode]="PatientCycleCode" [GradingModel]="GradingModel"
                          *ngIf="SemanAnalysis2.ActivityStatus =='Completed' || SemanAnalysis2.ActivityStatus =='Initiated'"></spermcollection2>
      </div>

      <div *ngIf="InseminationData2">
        <!--<insemination [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode" [GradingModel]="GradingModel"  *ngIf="InseminationData2.ActivityStatus =='Completed' || InseminationData2.ActivityStatus =='Initiated'"></insemination>-->
        <insemination2 (GoFollicle)="OnGoFollicle()" [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode"
                       [GradingModel]="GradingModel"
                       *ngIf="InseminationData2.ActivityStatus =='Completed' || InseminationData2.ActivityStatus =='Initiated'"></insemination2>
      </div>
      <div class="row" *ngIf="EmbryoGradingData2">
        <div class="col-md-6">
          <gradingview (GoFollicle)="OnGoFollicle()" [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode"
                       [GradingModel]="GradingModel"
                       *ngIf="EmbryoGradingData2.ActivityStatus =='Completed' || EmbryoGradingData2.ActivityStatus =='Initiated'"></gradingview>
        </div>
        <div class="col-md-6">
          <freezingview (GoFollicle)="OnGoFollicle()" [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode"
                        [GradingModel]="GradingModel"
                        *ngIf="EmbryoGradingData2.ActivityStatus =='Completed' || EmbryoGradingData2.ActivityStatus =='Initiated'"></freezingview>

        </div>
      </div>
      <div *ngIf="EmbryoTransferData2">
        <!--<etview [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode" [GradingModel]="GradingModel"  *ngIf="EmbryoTransferData2.ActivityStatus =='Completed' || EmbryoTransferData2.ActivityStatus =='Initiated' || EmbryoGradingData2.ActivityStatus =='Completed' || EmbryoGradingData2.ActivityStatus =='Initiated'" ></etview>-->
        <etview2 (GoFollicle)="OnGoFollicle()" [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode"
                 [GradingModel]="GradingModel"
                 *ngIf="EmbryoTransferData2.ActivityStatus =='Completed' || EmbryoTransferData2.ActivityStatus =='Initiated'"></etview2>
      </div>
      <div *ngIf="EmbryoTransferData2">

        <pregencytracker [ActorCode]="PatientActorCode" [CycleCode]="PatientCycleCode" [GradingModel]="GradingModel"
                         *ngIf="EmbryoTransferData2.ActivityStatus =='Completed' || EmbryoTransferData2.ActivityStatus =='Initiated'"></pregencytracker>
      </div>

      <div id="bottom">

      </div>







    </div>
    <div class="col-md-3 padding-left-0px padding-right-0px">
      <div class="row height-100pe background-primary margin-left-0px">
        <div class="position-fixed-Activities">

          <div class="col-md-12 padding-left-0px padding-right-0px">
            <div class="card">
              <div class="card-header wh-header  padding-left-0px padding-right-0px border-bottom-0px padding-top-0px margin-top-0px padding-bottom-0px">
                <ul class="nav nav-tabs nav-tab-ivf margin-top-3px" id="tabContent">
                  <li class="active nav-link-hand margin-right-5px"><a class="nav-item-ivf active" href="#details" data-toggle="tab">Activities</a></li>
                  <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#access-security" data-toggle="tab">Forms</a></li>
                  <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#rx" data-toggle="tab">Rx</a></li>
                  <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#lab" data-toggle="tab">Lab</a></li>

                </ul>
              </div>
              <div class="card-body padding-all-0px">
                <div class="tab-content">
                  <div class="tab-pane active" id="details">

                    <cycleactivities [ActorCode]="ActorCode" [CycleCode]="CycleCode" [LMPDate]="LMPDate"></cycleactivities>
                  </div>
                  <div class="tab-pane" id="access-security">
                    <div class="card">
                      <div class="card-body padding-bottom-0px padding-top-3px">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">


                                  <div class="col-md-12">
                                    <CustomDataByRequestType RequestedType="FDActorReports" ActorCode={{SelectedActorCode}}
                                                             id="CurrentFdActorReportsDocController.TemplateName" SelectedValue=""
                                                             [(ngModel)]="SelectedReport"
                                                             (keyChange)="onAssignedToActorCode($event)"
                                                             name="CurrentFdActorReportsDocController.TemplateName">
                                    </CustomDataByRequestType>
                                    <!--<CodeTypeValue CodeType="RELTP"></CodeTypeValue>-->


                                  </div>
                                  <div class="chatsd product-chart-wrapper product-chat-width-Form agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                    <div *ngIf="fo && fo.AutoSections" class="margin-top-10">


                                      <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let section of  fo.AutoSections;let RowIndex = index">
                                        <div [id]="'accordion'+RowIndex">
                                          <div [ngSwitch]="section.SectionType">
                                            <div class="card-header wh-header font-size-16px  padding-top-0px padding-bottom-0px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                                              <h5 class="mb-0">
                                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                                        aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                                                  {{section.Data.Title}}

                                                </button>
                                              </h5>

                                            </div>
                                            <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                                                 [attr.data-parent]="'#accordion'+RowIndex">
                                              <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                                                <div class="row" *ngSwitchCase="'AttrVal'">
                                                  <div class="col-md-12 padding-l-0px padding-right-0px" *ngFor="let field of  section.Fields">


                                                    <div [ngSwitch]="field.Data.ValueType">
                                                      <div class="row" *ngSwitchCase="'Bool'">
                                                        <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data"
                                                                       mode="view2">
                                                        </auto-gen-bool>
                                                      </div>
                                                      <div class="row" *ngSwitchCase="'List'">
                                                        <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data"
                                                                       mode="view2">
                                                        </auto-gen-list>
                                                      </div>
                                                      <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                                                        <auto-gen-text class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-text>
                                                      </div>
                                                      <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                                                        <auto-gen-cvs class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-cvs>
                                                      </div>
                                                      <div class="row" *ngSwitchCase="'Date'">
                                                        <auto-gen-date class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-date>
                                                      </div>
                                                      <div class="row padding-bottom-10px" *ngSwitchCase="'Grid'">
                                                        <!--<label>Grid: {{field.Title}}</label>-->
                                                        <auto-gen-grid class="col-md-12" [field]="field" mode="view2"></auto-gen-grid>
                                                      </div>

                                                      <div class="row" *ngSwitchDefault>




                                                      </div>





                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="row" *ngSwitchCase="'Text'">
                                                  <div class="col-md-12 padding-l-0px padding-right-0px">
                                                    <!--*ngFor="let field of  section.Fields"-->

                                                    <div class="row">
                                                      <div class="col-md-12 " *ngFor="let field of section.Data.Fields">
                                                        <div class="row" *ngIf="field.ValueType=='Text'">

                                                          <div class="col-md-11 padding-left-0px padding-right-0px">

                                                            <textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" placeholder="Remarks"
                                                                      [ngModelOptions]="{standalone: true}"
                                                                      [(ngModel)]="field.Value" maxlength="600"></textarea>

                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="row" *ngSwitchCase="'Image'">
                                                  <div class="col-md-12 padding-l-0px padding-right-0px">
                                                    <!--*ngFor="let field of  section.Fields-->

                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <div class="table-component">
                                                          <div class="table-responsive">


                                                            <table class="table table-striped margin-left-zero">

                                                              <!--<thead class="">
                                                                <tr>
                                                                  <th class="min-width-0px width-57px padding-top-4px padding-bottom-4px"></th>

                                                                  <th class="width-53px padding-top-4px padding-bottom-4px">#</th>
                                                                  <th class="width-178px padding-top-4px padding-bottom-4px">Title</th>
                                                                  <th class="padding-top-4px padding-bottom-4px">Image</th>

                                                                  <th class="padding-top-4px padding-bottom-4px">Comments</th>
                                                                  <th class="padding-top-4px padding-bottom-4px"></th>
                                                                </tr>
                                                              </thead>-->
                                                              <tbody class="table-body">

                                                                <tr *ngFor="let field of section.Data.Fields; let RowIndex = index ">
                                                                  <!--<td class="padding-top-0px padding-bottom-0px ">

                                                                    <input type="checkbox" [(ngModel)]="field.IsSelected" />
                                                                    <i class="input-helper"></i>

                                                                  </td>-->
                                                                  <td class="padding-top-0px padding-bottom-0px ">{{RowIndex+1}}</td>

                                                                  <td class="padding-top-0px padding-bottom-0px ">
                                                                    <!--<input class="form-control " [(ngModel)]="field.Title" type="text" [ngModelOptions]="{standalone: true}" />-->
                                                                    <div><label class="margin-bottom-0px">{{field.Title}}</label></div>
                                                                    <div><label class="margin-bottom-0px"> {{field.Remarks}}</label></div>
                                                                  </td>
                                                                  <td class="padding-top-0px padding-bottom-0px padding-left-5px">

                                                                    <!--<div *ngIf="!field.HasImage">
                                                                      <button class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save">
                                                                        <i class="fas fa-ellipsis-h"></i>
                                                                      </button>
                                                                    </div>-->
                                                                    <div *ngIf="field.HasImage">
                                                                      <img class="img-circle-56 font-size-12px" [src]="field.ImageFile" onError="this.src='dummy.jpg';">
                                                                      <!--<button type="button" class="btn  btn-sm button-new-health margin-top-left" tooltip="Add" (click)="openDocContent(field)" *ngIf="field?.IsSelected"><i class="fas fa-plus nav-link-hand"></i></button>-->

                                                                    </div>
                                                                  </td>
                                                                  <!--<td class="padding-top-0px padding-bottom-0px">

                                                                    {{field.Remarks}}

                                                                  </td>-->
                                                                  <!--<td class="text-align-right padding-top-0px padding-bottom-0px">

                                                                    <a class="nav-link-hand font-size-20px margin-left-10px" title="Remove" *ngIf="field?.IsSelected"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                                                                  </td>-->



                                                                </tr>

                                                              </tbody>

                                                            </table>

                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <!--<label>{{f.Title}}</label>
                                                <label class="margin-left-auto"></label>-->

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <!--<div *ngFor="let l of CurrentFdActorReportsDocController">
                                          <label>{{l.TemplateName}}</label>
                                        </div>-->


                                      </div>

                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" id="rx">
                    <div class="chatsd product-chart-wrapper product-chat-width-test agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                      <div *ngFor="let l of CurrentIvfCycleMembersListController">
                        <medicineview [ActorCode]="l.MemberActorCode"
                                      [CycleCode]="l.TreatmentCycle"
                                      [SourceType]="l.SourceType"
                                      [Title]="l.MemberType">
                        </medicineview>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" id="lab">
                    <div class="chatsd product-chart-wrapper product-chat-width-test agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                      <div *ngFor="let l of CurrentIvfCycleMembersListController">
                        <testview [ActorCode]="l.MemberActorCode"
                                  [CycleCode]="l.TreatmentCycle"
                                  [SourceType]="l.SourceType"
                                  [Title]="l.MemberType"
                                  [LMPDate]="LMPDate">
                        </testview>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>


</div>
<!--User Profile wizardEnd-->
